var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-application--wrap grey lighten-4"},[_c('the-layout-toolbar'),_c('the-layout-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }